import { render } from "./layanan_lainnya.vue?vue&type=template&id=5db44c9d"
import script from "./layanan_lainnya.vue?vue&type=script&lang=js"
export * from "./layanan_lainnya.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__